import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  Checkbox,
  FormField,
  TextInput,
} from '../../../components';

const propTypes = {
  edit: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool,
};
const defaultProps = {
  edit: false,
  name: '',
  required: false,
};

function InputField({
  edit, name, required,
}) {
  if (edit) {
    return (
      <Card>
        <Card.Title>Text Input</Card.Title>
        <Card.Block>
          <FormField
            label="Name"
            input={TextInput}
            name="name"
            defaultValue={name}
          />
          <Box height="0.5em" />
          <Checkbox
            label="Required"
            name="required"
            defaultChecked={required}
          />
        </Card.Block>
      </Card>
    );
  }

  return (
    <div>
      <FormField
        label={name}
        input={TextInput}
        name={name}
      />
      <Box height="0.5em" />
    </div>
  );
}

InputField.propTypes = propTypes;
InputField.defaultProps = defaultProps;
export default InputField;
